<template>
	<v-modal>
		<template v-slot:header>
			<h1>Close Lead</h1>
		</template>
		<form class="wide" @submit.prevent="closeLead">
			<div>
				<fieldset>
					<div>
						<div class="sr-only">
							<legend><span>Close Lead</span></legend>
						</div>
						<div class="input-group">
							<label><span>Reason for closing lead </span>
								<div v-if="form.errors.get('reason')" class="error-block">
									<p v-html="form.errors.get('reason')"></p>
								</div>
								<select v-model="form.data.reason">
									<option value="">—</option>
									<option
										v-for="(option, value) in $enum('LeadClosedEnum').display()" :value="value"
										v-html="option"/>
								</select>
							</label>
							<template
								v-if="form.data.reason === $enum('LeadClosedEnum').getKey('invalidContactDetails')">
								<label class="checkbox"><span>Confirm Contact Details Are Invalid </span>
									<input v-model="form.data.confirm_invalid_contact_details" type="checkbox">
									<div v-if="form.errors.get('confirm_invalid_contact_details')" class="error-block">
										<p v-html="form.errors.get('confirm_invalid_contact_details')"></p>
									</div>
									<div class="help-block alert alert--warning">
										<p>You must only select this option if it is impossible to contact this client. This is not the same as a number ringing out or emails going unanswered.</p>
										<p>Both the phone number and email address must be incorrect.</p>
										<p>In order to continue, you must confirm that this is the case.</p>
									</div>
								</label>
							</template>
						</div>
					</div>
				</fieldset>
			</div>
		</form>
		<template v-slot:footer>
			<ul class="actions actions--right">
				<li>
					<button
						:disabled="form.processing" class="button button--secondary"
						@click.prevent="$vmodal.close()">Cancel
					</button>
				</li>
				<li>
					<process-button
						:processing="form.processing" class="button button--negative" text="Close" @click="closeLead"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>

export default {
	data() {
		return {
			form: this.newForm({
				reason: "",
				confirm_invalid_contact_details: false,
			}),
		};
	},

	props: {
		lead: {
			required: true,
			type: Object,
		},
	},

	methods: {
		closeLead() {
			this.form.patch(this.route("leads/:lead/close", this.lead)).then(response => {
				this.$store.commit("leads/UPDATE_ITEM", response.data);
				this.$store.dispatch("alertsStore/success", "Lead Closed");
				this.$vmodal.close();
			});
		},
	},
};
</script>
